import { CleverInvestments } from "./CleverInvestments";

export default CleverInvestments;
